import React from 'react';
import {CustomThemeContext} from './customTheme';

export function useCustomTheme() {
  const context = React.useContext(CustomThemeContext);
  if (context === undefined) {
    throw new Error('useSummary must be used within a CustomThemeProvider');
  }
  return context;
}
